export class ProgramBoardModel {
    constructor(ProgramId, Boards, SubscriptionType) {
      this.ProgramId = ProgramId;
      this.Boards = Boards;
      this.SubscriptionType = SubscriptionType
    }
  }